{
  "version": 1,
  "asset_id": "66638ca0-aee5-444f-b066-00b3a029fd33",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/66638ca0-aee5-444f-b066-00b3a029fd33/sleeve-ugi-dilated-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/66638ca0-aee5-444f-b066-00b3a029fd33/sleeve-ugi-dilated-800.jpg",
  "original_filename": "sleeve-ugi-dilated-800.jpg",
  "size": 63936,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T01:31:02Z"
}
